import { Reveal, ChapterTag } from "@/components/Reveal";
import { useLang } from "@/i18n";

const team = [
  {
    name: "R. Mendoza",
    image: "https://images.unsplash.com/photo-1745060594679-61578eb592f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg2NDg0NzUwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "A. Torres",
    image: "https://images.unsplash.com/photo-1765776830139-72b2184dae5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg2NDg0NzUwfDA&ixlib=rb-4.1.0&q=85",
  },
  { name: "L. García", initials: "LG" },
  { name: "M. Rivera", initials: "MR" },
];

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-28 lg:py-40 border-t border-white/10" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <Reveal>
            <ChapterTag index="02" label={t.about.tag} />
            <h2 className="font-display font-black tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white mt-6" data-testid="about-heading">
              {t.about.heading}
            </h2>
            <p className="mt-8 text-neutral-400 leading-relaxed max-w-lg">
              {t.about.body}
            </p>
            <ul className="mt-10 space-y-6">
              {t.about.values.map((v, i) => (
                <li key={i} className="flex gap-5 border-l-2 border-brand/60 pl-5" data-testid={`about-value-${i}`}>
                  <div>
                    <p className="font-display font-bold text-white">{v.k}</p>
                    <p className="text-sm text-neutral-500 mt-1">{v.v}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative rounded-xl overflow-hidden border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1624555130581-1d9cca783bc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW0lMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NjQ4NDc1MHww&ixlib=rb-4.1.0&q=85"
                alt="IP NET team working session"
                loading="lazy"
                className="w-full h-[420px] object-cover"
                data-testid="about-office-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-transparent to-transparent" />
              <p className="absolute bottom-5 left-6 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-300">
                {t.about.caption}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="team-grid">
          {team.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.08}>
              <div className="group border border-white/10 rounded-xl overflow-hidden bg-[#0A0A0F] transition-[border-color,transform] duration-500 hover:border-brand/60 hover:-translate-y-1" data-testid={`team-member-${i}`}>
                {m.image ? (
                  <img src={m.image} alt={`${m.name}, ${t.about.roles[i]}`} loading="lazy" className="w-full h-64 object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-700" />
                ) : (
                  <div className="w-full h-64 flex items-center justify-center bg-gradient-to-br from-brand-dark via-[#0A0A0F] to-[#0A0A0F]">
                    <span className="font-display font-black text-6xl text-brand-light/80">{m.initials}</span>
                  </div>
                )}
                <div className="p-5">
                  <p className="font-display font-bold text-white">{m.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 mt-1.5">{t.about.roles[i]}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
